import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { Skeleton } from 'Components/primitives/skeleton';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnSkeleton',
    props: {
        width: { type: String, required: false, default: 'w-full' },
        height: { type: String, required: false, default: 'h-4' },
        circle: { type: Boolean, required: false, default: false },
        rows: { type: Array, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        /** Returns true when the value is a Tailwind class (starts with a letter). */
        function isTwClass(value) {
            return /^[a-z]/i.test(value);
        }
        const widthClass = computed(() => isTwClass(props.width) ? props.width : undefined);
        const heightClass = computed(() => isTwClass(props.height) ? props.height : undefined);
        const widthStyle = computed(() => isTwClass(props.width) ? undefined : props.width);
        const heightStyle = computed(() => isTwClass(props.height) ? undefined : props.height);
        const __returned__ = { props, isTwClass, widthClass, heightClass, widthStyle, heightStyle, get Skeleton() { return Skeleton; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
